module.exports = "g-dynamic-form ::ng-deep mat-form-field {\n  max-width: 200px;\n  display: inline-block !important;\n  margin-right: 1vw; }\n"